/**
 * 招待フロー（/invite）で共通して使うユーティリティ。
 */

/**
 * エラーメッセージ抽出は全ページ共通の関心事になったため
 * `src/common/utils.ts` へ移設した（2026-09-22、DM 引受エラーの
 * マスキング対応）。既存の import を壊さないよう re-export する。
 */
export { extractErrorMessage } from "../../common/utils";

/**
 * 招待トークンが「期限切れ」で弾かれたかを判定する。
 *
 * BE は期限切れのときだけ `expired: true` を返す（署名不正・改竄は
 * `expired` なしのエラー）。期限切れのときだけ、リンクを取り直す導線を出す。
 */
export const isExpiredInviteError = (err: unknown): boolean =>
  (err as { data?: { expired?: unknown } } | undefined)?.data?.expired === true;
